import { useLanguage } from '../providers/LanguageProvider';

export function useTranslation() {
  const { t, locale, setLocale } = useLanguage();
  return { t, locale, setLocale };
}

